import { createDaisyChainStore } from './store';
import * as actions from './actions';
import * as selectors from './selectors';
import { compose } from 'ramda';

export function createInteractor({ interactors }) {
  const { session } = interactors;
  const store = createDaisyChainStore();

  const nextStep = () => {
    const list = selectors.nextSteps({
      itemDefinitions: session.selectors.itemDefinitions(session.getState()),
      items: session.selectors.items(session.getState()),
      currentMove: session.selectors.currentMove(session.getState()),
    });

    return selectors.deriveNextStep({
      currentStep: selectors.currentStep(store.getState()),
      filteredNextStepsList: list,
    });
  };

  return {
    selectors: {
      nextStep: () => nextStep(),
      nextStepRoute: () => selectors.routeFromStep(nextStep()),
      currentStep: compose(
        selectors.currentStep,
        store.getState
      ),
      isTerminalRoute: compose(
        selectors.isTerminalRoute,
        store.getState
      ),
    },
    actions: {
      setCurrent: compose(
        store.dispatch,
        actions.setCurrent
      ),
      clearCurrent: compose(
        store.dispatch,
        actions.clearCurrent
      ),
      isTerminalRoute: compose(
        store.dispatch,
        actions.isTerminalRoute
      ),
      goToNext: compose(
        store.dispatch,
        actions.goToNext
      ),
    },
  };
}
